module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "seckillAppInfo",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.seckillAppInfo,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "sku"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.seckillAppInfo.app_name),
      callback: function($$v) {
        _vm.$set(_vm.seckillAppInfo, "app_name", $$v)
      },
      expression: "seckillAppInfo.app_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [(_vm.seckillAppInfo.app_name != '') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showProduct()
      }
    }
  }, [_vm._v("修改商品")]) : _vm._e(), _vm._v(" "), (_vm.seckillAppInfo.app_name == '') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showProduct()
      }
    }
  }, [_vm._v("获取商品")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "每日特价图片 ",
      "prop": "publicity_img"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.seckillAppInfo.publicity_img
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("  ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [(_vm.seckillAppInfo.publicity_img != '') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisibleToMaterial = true
      }
    }
  }, [_vm._v("修改图片")]) : _vm._e(), _vm._v(" "), (_vm.seckillAppInfo.publicity_img == '') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisibleToMaterial = true
      }
    }
  }, [_vm._v("获取图片")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "original_price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": " 0.01-10000",
      "min": 0.01,
      "max": 10000
    },
    model: {
      value: (_vm.seckillAppInfo.original_price),
      callback: function($$v) {
        _vm.$set(_vm.seckillAppInfo, "original_price", $$v)
      },
      expression: "seckillAppInfo.original_price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特价",
      "prop": "particularly_price"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": " 0.01-10000",
      "min": 0.01,
      "max": 10000
    },
    model: {
      value: (_vm.seckillAppInfo.particularly_price),
      callback: function($$v) {
        _vm.$set(_vm.seckillAppInfo, "particularly_price", $$v)
      },
      expression: "seckillAppInfo.particularly_price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量",
      "prop": "total_num"
    }
  }, [_c('el-input-number', {
    attrs: {
      "placeholder": "1-100000",
      "min": 1,
      "max": 100000
    },
    model: {
      value: (_vm.seckillAppInfo.total_num),
      callback: function($$v) {
        _vm.$set(_vm.seckillAppInfo, "total_num", $$v)
      },
      expression: "seckillAppInfo.total_num"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "商品",
      "visible": _vm.dialogVisible,
      "modal-append-to-body": false,
      "width": "70%",
      "top": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.isShowProduct) ? _c('ProductPutWay', {
    attrs: {
      "modal-append-to-body": false,
      "kioskNoList": _vm.kioskNoList,
      "is_checkbox": _vm.is_checkbox
    },
    on: {
      "handle-selection-change": _vm.handleSelectionChange,
      "close-product": _vm.closeProduct
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择素材",
      "visible": _vm.dialogVisibleToMaterial,
      "modal-append-to-body": false,
      "width": "70%",
      "top": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleToMaterial = $event
      }
    }
  }, [_c('MaterialSelect', {
    attrs: {
      "modal-append-to-body": false,
      "feature": _vm.feature
    },
    on: {
      "listenAffirmResources": _vm.responseAffirmResources
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "16.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "last_step"
    },
    on: {
      "click": function($event) {
        _vm.lastStep()
      }
    }
  }, [_vm._v("上一步\n                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('seckillAppInfo')
      }
    }
  }, [_vm._v("保存修改")]), _vm._v(" "), (_vm.act_status == -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.startOrPaseAct('1')
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n                每日特价配置\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n                每日特价配置\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b24a912!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/SeckillApp.vue
// module id = 1081
// module chunks = 2